<template>
  <div class="emat-loader" v-if="loading" :class="{ global, container }">
    <img v-if="order" src="https://emat-charging.staging.coddin.nl/assets/charging-loader.gif" alt="">
    <beat-loader :loading="loading" :color="color" :size="size" v-else></beat-loader>
  </div>
</template>

<script>
import BeatLoader from 'vue-spinner/src/BeatLoader.vue';

export default {
  name: 'Loader',
  components: {
    BeatLoader
  },
  props: {
    /**
     * Sets the visibility
     */
    loading: {
      type: Boolean,
      required: true,
    },

    /**
     * Fixed position across the screen
     */
    global: {
      type: Boolean,
      default: false,
    },

    /**
     * Sets a container around the loader
     */
    container: {
      type: Boolean,
      default: false,
    },
    order: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      color: '#196CAE',
      size: '20px',
    }
  },
}
</script>

<style lang="scss" scoped>
.emat-loader {
  &.global {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &.container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 200px;
  }
}
</style>
